var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":function($event){return _vm.go_url(_vm.definition.details.annotation.url)}}},[_c('img',{staticStyle:{"border":"1px solid"},attrs:{"width":"100%","src":_vm.definition.details.screenshots[0].public_url}}),_vm._v("\n      "+_vm._s(_vm.definition.details.annotation.url)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }